import {checkAndSearch} from '../index.js';
import {setErrorState} from '../index.js';
import {unsetErrorState} from '../index.js';
const config = require('./config.yaml');
const $search = $('.js-search--extendable');

if ($search.length) {
	const $searchInput = $search.find('.js-search-input');
	const $searchButton = $search.find('.js-extendable-search-button');
	const $searchWrapperInput = $search.find('.js-search-wrapper-input');
	const $searchMessage = $search.find('.js-search-message');
	const $searchLabel = $search.find('.search__label');
	const $closeButton = $search.find('.search__icon-close');
	const searchHideMessageType = config.searchMessageBottom ? 'transition.slideUpOut' : 'transition.slideDownOut';
	const searchShowMessageType = config.searchMessageBottom ? 'transition.slideDownIn' : 'transition.slideUpIn';

	$searchButton.on('click', function (event) {
		const $this = $(this);

		if (!$this.hasClass('is-expand')) {
			event.preventDefault();
			unsetErrorState($search);

			$closeButton.velocity('fadeIn', 200);

			$searchButton.addClass('is-expand');
			$.Velocity($searchWrapperInput, 'transition.slideRightIn', 200)
				.then(() => {
					return $searchInput.focus();
				})
				.catch(err => console.error(err));
		}
	});

	$searchInput
		.on('focus', function () {
			$searchLabel.velocity('fadeOut', 200);
			$searchMessage.velocity(searchHideMessageType, 200);
			unsetErrorState($search);
		})
		.on('blur', function () {
			const $this = $(this);
			if ($this.val().length === 0) {
				$searchLabel.velocity('fadeIn', 200);
			}
		});

	$search.on('submit', function (event) {
		checkAndSearch(event, searchShowMessageType, $(this));
	});

	$closeButton.on('click', function (event) {
		closeForm();
	});

	$(document).on('click', function (event) {
		if (!$(event.target).closest('.js-search--extendable').length) {
			closeForm();
		}
	});

	function closeForm() {
		$.Velocity($searchWrapperInput, 'transition.slideRightOut', 200)
			.then(
				function () {
					if (config.cleanInputOnBlur) {
						$searchInput.val('');
						$searchLabel.velocity('fadeIn', 200);
					}

					$searchButton.removeClass('is-expand');
					$searchMessage.hide();
				}
			);
		unsetErrorState($search);
		$search.find('.title-search-result').hide();
	}
}



// WEBPACK FOOTER //
// ./temp/components/search-form/extendable/index.js